import { render } from "./TrainingSectionIconBlocks.vue?vue&type=template&id=0e5a767f&scoped=true"
import script from "./TrainingSectionIconBlocks.vue?vue&type=script&lang=js"
export * from "./TrainingSectionIconBlocks.vue?vue&type=script&lang=js"

import "./TrainingSectionIconBlocks.vue?vue&type=style&index=0&id=0e5a767f&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e5a767f"]])

export default __exports__